module.exports = __webpack_public_path__ + "img/google-pay.64b7da49.png";